import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import { initialState } from "../../../layout/table/helpers";
import ConditionalButton from "../../../layout/conditional-button";

import { send as pageInfo, loading } from "../../../actions/page";
import { withNavigation } from "../../../utils/wrapper";
import { search } from "../../../actions/pay.schedules";

class PaySchedules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState({ order: "name", size: 25 }),
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0
        };
        this.props.loading(true);
    }

    componentDidMount = async () => {
        await this.loadData();
    };

    loadData = async () => {
        this.props.loading(true);

        try {
            const { page, size, order, direction, search } = this.state;

            const result = await this.props.search({
                search,
                page,
                size,
                order,
                direction,
            });

            const count = Number(result?.count ?? 0);
            const pages = size > 0 ? Math.ceil(count / Number(size)) : 0;

            this.setState({
                data: Array.isArray(result?.items) ? result.items : [],
                pages,
            });

            await this.props.pageInfo({ title: "Pay Schedules", breadcrumb: "Pay Schedules" });
        } finally {
            this.props.loading(false);
        }
    };

    get headers() {
        return [
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-50",
                onRender: this.onLinkFormat,
            },
            {
                header: "Frequency",
                sortable: true,
                source: "frequency",
                className: "text-muted text-small text-uppercase w-25",
                onRender: this.onFrequencyFormat,
            },
            {
                header: "Anchored",
                sortable: true,
                source: "anchorDate",
                className: "text-muted text-small text-uppercase w-25",
                onRender: this.onDateFormat,
            }
        ];
    }

    onDateFormat = (e) => {
        if (!e) return "";
        const s = String(e);
        return s.length >= 10 ? s.slice(0, 10) : s;
    };

    onFrequencyFormat = (e) => e || "";

    onLinkFormat = (e, row) => {
        const text = e || row?.uuid || "";
        return (
            <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => this.props.navigate(`/dashboard/accounting/payschedules/${row?.uuid}`)}
            >
                {text}
            </button>
        );
    };

    onNewClick = () => {
        this.props.navigate("add");
    };

    onSearch = (search) => {
        this.setState({ search: search ?? "", page: 0 }, this.loadData);
    };

    onSize = (size) => {
        this.setState({ size: Number(size), page: 0 }, this.loadData);
    };

    onPageChange = (page) => {
        this.setState({ page: Number(page) }, this.loadData);
    };

    onColumnClick = (e) => {
        const columns = this.headers;
        const nextIndex = columns.findIndex(
            (item) => item.header === e?.header && item.source === e?.source
        );
        if (nextIndex < 0 || !columns[nextIndex]?.sortable) return;

        const nextOrder = columns[nextIndex].source;
        const nextDirection =
            this.state.index === nextIndex && this.state.direction === "DESC" ? "ASC" : "DESC";

        this.setState(
            {
                index: nextIndex,
                order: nextOrder,
                direction: nextDirection,
                page: 0
            },
            this.loadData
        );
    };

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton
                        enabledVariant="outline-primary"
                        tooltip="Create new pay schedule"
                        display
                        enabled={true}
                        onEnabledClick={this.onNewClick}
                        icon="flash"
                    >
                        New
                    </ConditionalButton>
                </Col>

                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable
                        sizable
                    />
                </Col>
            </>
        );
    }
}

PaySchedules.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default withNavigation(
    connect(mapStateToProps, { search, loading, pageInfo })(PaySchedules)
);
